import React from 'react'
import Title from './Title'
import TOCList from './TOCList'

const TOC = ({ curriculumData = [] }) => {
  return (
    <div className='w-full flex flex-col gap-3'>
      <Title />
      <TOCList curriculumData={curriculumData} />
    </div>
  )
}

export default TOC